import React from 'react';
import { Icon } from 'semantic-ui-react';
import * as Styles from './ClientsTickets.styles';
import LoadingImage from 'assets/svg/loading.svg';
import { useHistory } from 'react-router-dom';
import { navLinks } from 'utils/nav-links-util';
import { H5 } from 'utils/resuable-css';
import TicketsDetailContainer from 'components/support/components/TicketsDetailContainer';
import { useTranslation } from 'react-i18next';

const ClientsTickets = ({ getTickets, loadingTickets, getSubStatus, getDeparment, loadingUrl, handlePortalLogin }) => {
  let history = useHistory();
  const { t } = useTranslation();
  return (
    <Styles.DraggableContainer id="alertParent">
      <div>
        <div id="alertChild">
          <Styles.TopBar>
            <Styles.Left>
              <Icon name="ticket alternate" color="black" />
              <H5>{t('dashboard.string23')}</H5>
              {loadingTickets && <img src={LoadingImage} height={28} alt="loading" />}
            </Styles.Left>
            <Styles.Right>
              <Icon name="expand" onClick={() => history.replace(navLinks.view_user_tikets.link)} />
            </Styles.Right>
          </Styles.TopBar>
        </div>
        <Styles.Content>
          <div>
            {getTickets?.tickets?.map((val) => {
              const { ticket_substatus_definitions: subStatusList } = getSubStatus || {};
              const subStatus = subStatusList?.find((status) => status.id === val.substatus);

              const { ticket_department_definitions: departmentList } = getDeparment || {};
              const department = departmentList?.find((dep) => dep.id === val.department);

              return (
                <TicketsDetailContainer
                  loadingUrl={loadingUrl}
                  handlePortalLogin={handlePortalLogin}
                  key={val.id}
                  val={val}
                  department={department}
                  subStatus={subStatus}
                />
              );
            })}
          </div>
        </Styles.Content>
      </div>
    </Styles.DraggableContainer>
  );
};
export default ClientsTickets;
